// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3yScp","header":"ClearentDisclaimer_header__2trgY","inner":"ClearentDisclaimer_inner__3P2Oo"};